module.exports = __webpack_public_path__ + "img/audio_classify1.a741ac58.png";